export const deliverabilityEmailAppGroupIdFilters = "/deliverability/email/:app_group_id/filters";
